/** Thin wrapper over the shared `.input` style. */
export default function Input({ type = 'text', className = '', ...props }) {
  return <input type={type} className={`input ${className}`} {...props} />;
}
